const penalServices = [
  'Asesoría jurídica desde el inicio de una investigación penal.',
  'Defensa y representación de personas imputadas.',
  'Representación y acompañamiento de víctimas.',
  'Asistencia en declaraciones y diligencias judiciales.',
  'Análisis de investigaciones y valoración de la prueba.',
  'Preparación y seguimiento de estrategias de defensa.',
  'Acompañamiento durante las diferentes etapas del proceso penal.',
  'Solicitud y seguimiento de medidas cautelares.',
  'Interposición y contestación de recursos.',
  'Atención y seguimiento de procesos penales de diversa naturaleza.',
];

const familyServices = [
  'Procesos de divorcio y disolución del vínculo matrimonial.',
  'Procesos de pensión alimentaria y su ejecución.',
  'Procesos de interrelación familiar.',
  'Conflictos relacionados con el ejercicio de los atributos de la responsabilidad parental.',
  'Procesos de pérdida o suspensión de la responsabilidad parental.',
  'Procesos de filiación y reconocimiento de vínculos familiares.',
  'Reconocimiento de uniones de hecho.',
  'Procesos de ejecución derivados de resoluciones judiciales.',
  'Procesos de violencia doméstica.',
  'Procesos de protección cautelar.',
  'Salvaguardia para la igualdad jurídica de las personas con discapacidad.',
  'Representación y protección de personas menores de edad en el ámbito administrativo.',
  'Atención de conflictos parentales y otras situaciones que requieren intervención judicial o administrativa.',
];

const civilServices = [
  'Procesos de ejecución hipotecaria y prendaria.',
  'Procesos monitorios de cobro judicial, arrendaticios y ordinarios civiles.',
  'Procesos de responsabilidad civil.',
  'Incumplimientos contractuales.',
  'Elaboración y revisión de contratos civiles.',
  'Conflictos derivados de arrendamientos.',
  'Procesos sucesorios judiciales.',
  'Procesos de prescripción positiva (usucapión).',
  'Conflictos sobre derechos de propiedad y posesión.',
  'Constitución y defensa de servidumbres.',
  'Procesos de nulidad de contratos y actos jurídicos.',
  'Reclamaciones por vicios ocultos.',
  'Ejecución de sentencias civiles.',
  'Embargos y remates judiciales.',
  'Medidas cautelares civiles.',
  'Negociaciones y acuerdos extrajudiciales.',
  'Asesoría y representación en conflictos patrimoniales.',
  'Interdictos.',
];

const notarialServices = [
  'Compraventa de propiedades y vehículos.',
  'Traspasos de bienes muebles e inmuebles.',
  'Constitución y cancelación de hipotecas.',
  'Constitución de sociedades mercantiles.',
  'Protocolización de actas.',
  'Otorgamiento de poderes generales y especiales.',
  'Matrimonios civiles.',
  'Divorcios y sucesiones en sede notarial.',
  'Testamentos.',
  'Declaraciones juradas.',
  'Autenticación de firmas.',
  'Certificaciones notariales.',
  'Segregación y reunión de propiedades.',
  'Constitución de servidumbres.',
  'Donaciones de bienes muebles e inmuebles.',
];

export default function ServicesContent() {
  return (
    <>
      <h2 id="penal" className="scroll-mt-28">Derecho Penal:</h2>
      <p className="text-base md:text-lg text-foreground-800">Defensa técnica, estrategia jurídica y acompañamiento humano en momentos que pueden cambiar una vida.</p>
      <p>En materia penal, brindamos asesoría, defensa y representación legal a personas que enfrentan un proceso judicial, así como a quienes han sido víctimas de un delito y necesitan acompañamiento para hacer valer sus derechos.</p>
      <p>Nuestra experiencia comprende la representación de personas imputadas y víctimas, lo que nos ha permitido conocer y comprender las distintas perspectivas y realidades que convergen dentro de un proceso penal. Esta experiencia nos permite abordar cada caso con una visión amplia, rigurosa y estratégica, procurando siempre la adecuada protección de los derechos e intereses de nuestros clientes.</p>
      <p>Nuestra intervención puede iniciar desde las primeras etapas de una investigación y extenderse a las diferentes fases del proceso penal.</p>
      <p>Analizamos cuidadosamente las circunstancias particulares de cada caso, la prueba disponible y las alternativas jurídicas existentes, con el propósito de construir una estrategia de defensa o representación acorde con las necesidades de cada persona.</p>
      <p>Entre nuestros servicios se encuentran:</p>
      <ul>
        {penalServices.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <p>Entendemos que enfrentar una situación penal puede generar incertidumbre, temor y una enorme carga emocional. Por eso, nuestra labor no consiste únicamente en ejercer una defensa desde el punto de vista jurídico. También buscamos que la persona comprenda lo que está sucediendo, conozca sus derechos y cuente con un abogado que la acompañe con seriedad, cercanía y humanidad durante todo el proceso.</p>

      <h2 id="familia" className="scroll-mt-28">Derecho de Familia:</h2>
      <p>El Derecho de Familia involucra algunas de las situaciones más personales y sensibles que una persona puede enfrentar. Por ello, nuestra labor combina el conocimiento jurídico, la experiencia en litigio y un acompañamiento cercano y humano, procurando que cada cliente comprenda sus derechos, sus alternativas y las consecuencias de las decisiones que debe tomar.</p>
      <p>El Máster León Felipe Ramos Santos cursó la Especialización en Derecho de Familia entre los años 2024 y 2025, otorgada por el Colegio de Abogados y Abogadas de Costa Rica en marzo de 2025. Esta formación especializada forma parte de su compromiso con la actualización y formación permanente en esta área del Derecho, y complementa su experiencia de más de dos décadas en la atención y litigio de asuntos relacionados con el Derecho de Familia.</p>
      <p>Contamos con experiencia en la atención y tramitación de procesos relacionados con las distintas etapas y conflictos de la vida familiar, entre ellos:</p>
      <ul>
        {familyServices.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <p>Nuestra experiencia nos ha permitido acompañar a madres, padres, personas menores de edad y otros integrantes de la familia en circunstancias que requieren no solamente una adecuada estrategia jurídica, sino también sensibilidad y comprensión de las dinámicas humanas que existen detrás de cada proceso. Entendemos que un conflicto familiar rara vez es únicamente un asunto legal. Puede involucrar emociones, relaciones personales, hijos, patrimonio y decisiones que tendrán consecuencias durante muchos años. Por eso, procuramos brindar una asesoría clara y responsable, buscando proteger los derechos de nuestros clientes y, cuando están involucradas personas menores de edad o personas en condición de vulnerabilidad, prestar especial atención a su protección y bienestar. En Derecho de Familia, acompañar también significa comprender que detrás de cada proceso existen vínculos, historias y personas.</p>

      <h2 id="civil" className="scroll-mt-28">Derecho Civil:</h2>
      <p className="text-base md:text-lg text-foreground-800">Soluciones jurídicas para proteger sus derechos, su patrimonio y sus relaciones personales y contractuales.</p>
      <p>El Derecho Civil está presente en muchas de las decisiones y situaciones que forman parte de la vida cotidiana: contratos, propiedades, obligaciones, herencias, arrendamientos, cobros y conflictos que pueden requerir una intervención judicial.</p>
      <p>El Máster León Felipe Ramos Santos cursó la Maestría en Administración de Justicia Enfoque Socio – Jurídico con énfasis en Administración de Justicia Civil en la Universidad Nacional de Costa Rica entre los años 2010 y 2011, obteniendo su título en 2011. Esta formación especializada complementa una trayectoria de más de dos décadas de ejercicio profesional y litigio en materia civil.</p>
      <p>Brindamos asesoría, representación y acompañamiento jurídico tanto en la prevención de conflictos como en su resolución, procurando que cada asunto sea analizado de manera integral y que nuestros clientes conozcan con claridad sus derechos, obligaciones y alternativas.</p>
      <p>Nuestra experiencia comprende la atención y tramitación de asuntos civiles de diversa naturaleza, entre ellos:</p>
      <ul>
        {civilServices.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <p>Nuestra práctica en materia civil combina la formación especializada con la experiencia adquirida en el litigio judicial, así como una visión orientada, cuando es posible, a la prevención de conflictos. Analizamos cada situación procurando no solamente responder al problema inmediato, sino también anticipar sus posibles consecuencias jurídicas.</p>
      <p>Porque un contrato, una propiedad, una herencia o una obligación pueden representar una parte importante del patrimonio y de la tranquilidad de una persona o una familia, nuestro compromiso es brindar una atención rigurosa, clara y cercana, acompañando al cliente desde la valoración inicial de su situación hasta la conclusión del asunto.</p>
      <p>En Derecho Civil, prevenir adecuadamente puede ser tan importante como saber defenderse cuando el conflicto ya existe.</p>
      <h3 id="notarial" className="scroll-mt-28">Función notarial:</h3>
      <p>También contamos con experiencia en el ejercicio de la función notarial, brindando asesoría y formalización de actos y negocios jurídicos que requieren seguridad, claridad y respaldo profesional.</p>
      <ul>
        {notarialServices.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </>
  );
}